<div class="w-full bg-white border-box radius-10" style="border-radius: 10px;" id="election-information">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Etablissement dans lequel s'est déroulé l'élection</p>
        <p class="no-margin dark-gray text-sm">Toutes les informations de cette section sont obligatoires</p>
      </div>
    </div>

  </div>


  <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;" id="information-grid" class="p-20">
    <div>
      <p class="dark-blue no-margin">Raison sociale <span class="red">*</span></p>
      <input [(ngModel)]="venue.legalName" (ngModelChange)="onVenueChange()" type="text" name="raison_sociale"
        id="raison_sociale" class="w-full text-md dark-blue pap-input" value="{{venue.legalName}}">
    </div>

    <div>
      <p class="dark-blue no-margin">Numéro de convention collective (IDCC) <span class="red">*</span></p>
      <input [(ngModel)]="venue.idcc" (ngModelChange)="onVenueChange()" type="text" name="forme_juridique"
        id="forme_juridique" class="w-full text-md dark-blue pap-input" value="{{venue.idcc}}"
        (keypress)="onlyNumbers($event)" pattern="[0-9]*" inputmode="numeric" maxlength="4">
    </div>

    <div>
      <p class="dark-blue no-margin">SIRET <span class="red">*</span></p>
      <input [(ngModel)]="venue.siret" (ngModelChange)="onVenueChange()" (keypress)="onlyNumbers($event)" type="text"
        name="siret" id="siret" maxlength="14" pattern="[0-9]*" inputmode="numeric"
        class="w-full text-md dark-blue pap-input" value="{{venue.siret}}">
    </div>

    <div></div>

    <div style="grid-column: 1 / -1;">
      <p class="dark-blue no-margin">Adresse <span class="red">*</span></p>
      <input [(ngModel)]="venue.address" (ngModelChange)="onVenueChange()" type="text" name="address" id="address"
        class="w-full text-md dark-blue pap-input" value="{{venue.address}}">
    </div>

    <div>
      <p class="dark-blue no-margin">Code Postal <span class="red">*</span></p>
      <input [(ngModel)]="venue.zipcode" (ngModelChange)="onVenueChange()" type="text" name="postal_code" id="zip"
        class="w-full text-md dark-blue pap-input" value="{{venue.zipcode}}" maxlength="11">
    </div>

    <div>
      <p class="dark-blue no-margin">Ville / Commune <span class="red">*</span></p>
      <input [(ngModel)]="venue.city" (ngModelChange)="onVenueChange()" type="text" name="city" id="city"
        class="w-full text-md dark-blue pap-input" value="{{venue.city}}">
    </div>

  </div>
</div>